import {DigitalRevisionMenuItem} from '../../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Extras',
    ImagePath: '/assets/images/landing/pdfs.png',
    DestinationPage: 'extras',
  },
  {
    Text: 'Exam Practice',
    ImagePath: '/assets/images/landing/online-workbook.png',
    DestinationPage: 'exam-practice-questions',
  },
  {
    Text: 'Multiple Choice',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.ExamPracticeQuestions,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: 'exam-practice-questions',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/CAQ72/CAQ72_DigitalWorkbook_v1_FreeSample',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples, then see how it\'s going with your progress tracker.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Multiple Choice Test',
    ButtonURL: 'quick-quiz',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/CAQ72/CAQ72_QuickQuiz_v1_FreeSample',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Mutiple Choice Tests',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Repeating makes perfect! Get stuck into our exam-style tests to build up your skills</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Short bursts of targeted practice',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Get access with your book',
    ButtonURL: 'extras',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: true,
    IsSwitcher: false,
    MainContentText: '<p>Printable multiple choice tests, resource sheets and exam tips  -  it\'s all right here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      HeaderText: 'Extra Useful Bits',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Take a look at the FAQs if you need some help.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your A-Level Science Workbooks. Use the exam practice questions, multiple choice tests and more to make sure you know your stuff for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working  -  what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>There are no takie-backsies in CGP RevisionHub, so you can\'t clear your results and start again. But, you can have another go at any of the exam practice questions or tests and they\'ll update to show your latest scores. Keep going, we believe in you!</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions  -  what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/as-and-a-level',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];